import ReactMarkdown from "react-markdown";
import Section from "./Section";
import React, { useEffect, useState } from "react";

//import termsContent from "./terms.md";

function TermsOfService() {

    const [termsContent, setTermsContent] = useState("");

    useEffect(() => {
        fetch("/policies/terms.md")
        .then((res) => res.text())
        .then((text) => setTermsContent(text));
    }, []);

  return (
    <Section size="lg" bgColor="bg-white" textColor="text-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-16 space-y-6">
        <ReactMarkdown className="prose prose-lg text-gray-700">
          {termsContent}
        </ReactMarkdown>
      </div>
    </Section>
  );
}

export default TermsOfService;
